import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Body, Heading } from '../../typography';

const AssignmentNotStarted = ({ assignment }) => {
    const date = moment(assignment.startDate).format('DD/MM/YYYY');
    const time = moment(assignment.startDate).format('hh:mm');
    return (
        <>
            <Heading level={2} weight="light">
                {'Non puoi ancora svolgere questa prova'}
            </Heading>
            <br />
            <Body>{`Potrai svolgere questa prova a partire dal ${date} alle ${time}.`}</Body>
            <br />
            <Body>{`Hai bisogno di aiuto? Contattaci`}</Body>
            <br />
        </>
    );
};

AssignmentNotStarted.propTypes = {
    assignment: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        assignment: state.assignment,
    };
}

export default connect(mapStateToProps)(AssignmentNotStarted);
